export enum ValidationMessage {
  FIELD_REQUIRED = `This field is required.`,
}

export const EmailValidation = {
  PATTERN:
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  MESSAGE: `Entered value does not match email format of example@example.com`,
}

export const PasswordValidation = {
  PATTERN: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/,
  MESSAGE: `Requires 8 characters minimum with at least 1 number, 1 uppercase letter, and 1 lowercase letter.`,
}

export const PhoneValidation = {
  PATTERN: /^(0|\+?64)[0-9]{8,}$/,
  MESSAGE: `Please enter a valid phone number`,
}

export const UrlValidation = {
  PATTERN:
    /^[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_.~#?&//=]*)$/,
  MESSAGE: `Please enter a valid URL matching www.example.com`,
}
